<template>
  <div>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="contactPersons"
      :items-per-page="10"
      :footer-props="footerProps"
      :sort-by="sortBy"
      sort-desc
    >
      <template v-slot:item.salutation="{ item }">
        <span v-if="item.salutation">{{
          $t(
            'PROFILE.SALUTATIONS_SHORT.' +
              item.salutation.substring(0, item.salutation.length - 1)
          )
        }}</span>
      </template>

      <template v-slot:item.full_name="{ item }">{{
        getFullName(item)
      }}</template>

      <template v-slot:item.action="{ item }">
        <slot name="actions" :item="item" />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ContactPersonsList',

  props: {
    contactPersons: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    sortBy: 'id',
    footerProps: {
      showFirstLastPage: true,
      itemsPerPageOptions: [10, 50, 100]
    }
  }),

  computed: {
    ...mapState(['loading']),
    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('PROFILE.SALUTATION'),
          value: 'person.salutation'
        },
        {
          text: this.$t('PROFILE.FULL_NAME'),
          value: 'person.full_name'
        },
        {
          text: this.$t('PROFILE.DEPARTMENT'),
          value: 'department'
        },
        {
          text: this.$t('PROFILE.POSITION'),
          value: 'position'
        },
        {
          text: this.$t('PROFILE.WORK_EMAIL'),
          value: 'email'
        },
        {
          text: this.$t('PROFILE.PHONE'),
          value: 'phone'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          align: 'center'
        }
      ];
    }
  },

  methods: {
    getFullName(item) {
      const first = item.first_name || '';
      const last = item.last_name || '';

      return `${first} ${last}`.trim();
    }
  }
};
</script>
